// no zero or letter O to avoid confusion
export const alphabet = '123456789ABCDEFGHIJKLMNPQRSTUVWXYZ'
export const inviteKeyLength = 16

export const OFFER_EXPIRATION_DAYS_MIN = 7
export const OFFER_EXPIRATION_DAYS_MAX = 365
export const OFFER_EXPIRATION_DAYS_DEFAULT = 30
